import React from 'react'
import { Box, Typography } from '@mui/material'
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined'
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined'
import {
  HappyCustomerRatings,
  HappyCustomers,
  TrustPilotRating
} from '../../../../../GlobalVariables/Numbers'
import FeatureListItem from '@zuto/atoms/src/Mui/Card/FeatureListItem'
import { FeatureListItemType } from '../../../../../types/ui'
import { formlessColors } from '@zuto/theme/src/mui/Colors'

const whyItems = (isClearscore: boolean): FeatureListItemType[] => [
  {
    icon: {
      component: StarBorderOutlinedIcon,
      bg: formlessColors.surfaceGreenSoft,
      color: formlessColors.iconGreen
    },
    title: 'Rated Excellent ★★★★★',
    description: `Rated ${TrustPilotRating} stars by over ${HappyCustomerRatings} happy customers on Trustpilot.`
  },
  {
    icon: {
      component: GroupsOutlinedIcon,
      bg: formlessColors.surfaceBlueSoftAlt,
      color: formlessColors.iconBlue
    },
    title: `Over ${HappyCustomers} Million Happy Customers`,
    description: `Over ${HappyCustomers} million people have trusted us to help finance their dream car.`
  },
  {
    icon: {
      component: WorkspacePremiumOutlinedIcon,
      bg: formlessColors.surfaceAmberSoft,
      color: formlessColors.iconAmber
    },
    title: isClearscore ? "ClearScore's Exclusive Partner" : "Large Panel of Trusted Lenders",
    description: isClearscore
      ? 'Chosen by ClearScore as their exclusive car finance partner for exceptional service.'
      : 'We will search our large panel of lenders to find the best deal for you.'
  },
  {
    icon: {
      component: PhoneInTalkOutlinedIcon,
      bg: formlessColors.surfacePurpleSoftAlt,
      color: formlessColors.iconPurple
    },
    title: 'Dedicated Car Buying Expert',
    description:
      'Speak to real people who are on hand to guide you smoothly through the process to drive away happy!'
  }
]

const WhyCustomersLoveZuto: React.FC<{ source: string }> = ({ source }) => {
  const isClearscore = source === "clearscore"
  const items = whyItems(isClearscore)
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: formlessColors.pageBgGrey,
        padding: '40px 16px 48px',
        color: 'common.white',
        boxSizing: 'border-box'
      }}
      component="section"
      id="customers-love-zuto"
    >
      <Box
        sx={{
          maxWidth: '960px',
          margin: '0 auto',
          textAlign: 'center'
        }}
      >
        <Typography component="h2" variant="headlineMedium" sx={{ color: 'common.white' }}>
          Why customers love Zuto ❤️
        </Typography>

        <Typography typography="bodyLarge" sx={{ color: 'common.white' }} mb={7}>
          We make buying your next car simple, transparent, and
          stress-free.
        </Typography>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, minmax(0, 1fr))'
            },
            gap: '16px',
            boxSizing: 'border-box'
          }}
        >
          {items.map((item) => (
            <FeatureListItem
              key={item.title}
              {...item}
              sx={{
                padding: '16px 18px',
                boxShadow: '0 10px 25px rgba(15,23,42,0.18)',
                border: 'none'
              }}
              iconWrapperSx={{
                width: '32px',
                height: '32px',
                borderRadius: '999px',
                marginRight: 5
              }}
              titleSx={{
                fontWeight: 700,
                marginBottom: 1
              }}
              descriptionSx={{
                color: formlessColors.textMuted
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default WhyCustomersLoveZuto
